export const BASE_URL = 'https://alawdaschool-api.midadworld.com/api';

export const LOCAL_STORAGE_NAME = 'midad-local-storage';